<div class="app-main__inner">
  <div class="app-page-title">
    <div class="page-title-wrapper">
      <div class="page-title-heading">
        <div class="page-title-icon">
          <i class="{{ icon }} icon-gradient bg-mean-fruit"></i>
        </div>
        <div>
          {{ title }}
          <div class="page-title-subheading">{{ subheading }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="mb-3 card">
    <div class="card-body">
      <div class="d-flex justify-content-end mb-3">
        <button
          type="button"
          class="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#addMasterModal"
          (click)="resetForAdd()"
        >
          <i class="fa fa-plus me-1"></i> {{ addButtonLabel }}
        </button>
      </div>

      <div *ngIf="errorMessage" class="alert alert-danger" role="alert">{{ errorMessage }}</div>

      <div *ngIf="isLoading" class="text-center text-muted py-4">Loading...</div>

      <div *ngIf="!isLoading && !records.length && !errorMessage" class="text-center text-muted py-4">
        No entries yet.
      </div>

      <vio-table-v2 *ngIf="!isLoading && records.length" [tableData]="records" [tableConfig]="tableConfig"></vio-table-v2>
    </div>
  </div>
</div>

<!-- Add Modal -->
<div
  class="modal fade"
  id="addMasterModal"
  tabindex="-1"
  aria-labelledby="addMasterModalLabel"
  aria-hidden="true"
  #addMasterModal
>
  <div class="modal-dialog">
    <div class="modal-content">
      <form (ngSubmit)="addRecord()" #masterForm="ngForm">
        <div class="modal-header">
          <h5 class="modal-title" id="addMasterModalLabel">{{ addButtonLabel }}</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label" for="masterNewName">{{ fieldLabel }} <span class="text-danger">*</span></label>
            <input
              id="masterNewName"
              type="text"
              class="form-control"
              name="newName"
              [(ngModel)]="newName"
              required
            />
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="submit" class="btn btn-primary" [disabled]="!masterForm.form.valid || isSaving">
            {{ isSaving ? 'Saving...' : 'Save' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Employee List Modal -->
<div
  *ngIf="employeeField"
  class="modal fade"
  id="empListModal"
  tabindex="-1"
  aria-labelledby="empListModalLabel"
  aria-hidden="true"
  #empListModal
>
  <div class="modal-dialog modal-xl modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="empListModalLabel">
          <i class="fa fa-users me-2"></i>
          Employees — <span class="text-primary">{{ empListTitle }}</span>
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div *ngIf="filteredEmployees.length === 0" class="text-center text-muted py-5">
          <i class="fa fa-users-slash d-block mb-2" style="font-size: 2rem; opacity: 0.3;"></i>
          No employees found for <strong>{{ empListTitle }}</strong>.
        </div>
        <vio-table-v2
          *ngIf="filteredEmployees.length > 0"
          [tableData]="filteredEmployees"
          [tableConfig]="empListTableConfig"
        ></vio-table-v2>
      </div>
      <div class="modal-footer">
        <span class="me-auto text-muted small">{{ filteredEmployees.length }} employee(s)</span>
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
